import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";

import { ALL_PUBLISHED_STATES } from "../../../helper/publishedState";
import { useGetSupplier } from "../../../hooks/suppliers/useGetSupplier";
import { SupplierEditForm } from "../form/SupplierEditForm";


type AddEditSupplierDrawerProps = {


  isSupplierDrawerOpen: boolean;
  closeDrawerAction: () => void;
  setSupplierDrawerOpen: (v: boolean) => void;

  supplierIdToUpdate: string;
};


export const SupplierAddEditDrawer: React.FC<
  AddEditSupplierDrawerProps
> = ({ closeDrawerAction, supplierIdToUpdate, setSupplierDrawerOpen, isSupplierDrawerOpen }) => {
  const { t } = useTranslation();


  const {
    query: { data: supplier, refetch },
    queryKey
  } = useGetSupplier(
    supplierIdToUpdate ?? "",
    ALL_PUBLISHED_STATES
  );

  return (

    <Drawer
      title={t("managesuppliers.drawer.title")}
      placement="right"
      width={900}
      closable={true}
      onClose={() => closeDrawerAction()}
      open={isSupplierDrawerOpen}
      bodyStyle={{ padding: 10 }}

    >

      {isSupplierDrawerOpen && supplier
        && <SupplierEditForm
          isSupplierDrawerOpen={isSupplierDrawerOpen}
          closeDrawerAction={closeDrawerAction}
          setSupplierDrawerOpen={setSupplierDrawerOpen}
          supplier={supplier}
          refetch={refetch}
          queryKey={queryKey}
        />
      }

    </Drawer>
  );
};
